<template>
  <div class="flex items-center gap-3 py-2 border-b border-base-200 last:border-b-0">
    <div class="min-w-0 flex-1">
      <div class="text-sm font-medium truncate">{{ row.subject?.name || `User #${row.subject_id}` }}</div>
      <div class="text-xs opacity-70 truncate">{{ row.subject?.email || '' }}</div>
    </div>

    <PermissionBadge
      v-if="row.inherited"
      action="view"
      class="shrink-0"
    />
    <span
      v-if="row.inherited"
      class="text-xs opacity-70"
    >Inherited</span>

    <select
      v-if="!row.inherited"
      class="select select-bordered select-sm w-24"
      :value="row.action"
      @change="$emit('change', row, $event.target.value)"
    >
      <option
        v-for="action in actions"
        :key="action"
        :value="action"
      >{{ action }}</option>
    </select>

    <button
      v-if="!row.inherited"
      class="btn btn-ghost btn-sm text-error"
      @click.prevent="$emit('remove', row)"
    >
      Remove
    </button>
  </div>
</template>

<script>
import PermissionBadge from './PermissionBadge'

export default {
  name: 'PermissionRow',
  components: { PermissionBadge },
  props: {
    row: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      required: true
    }
  },
  emits: ['change', 'remove']
}
</script>

